export interface SenderListFilter {
  page?: number | null;
  count?: number | null;
  sort_key?: string | null;
  sort_by?: string | null;
  partner_id?: number[] | null;
  search?: string | null;
}

export const defaultSenderListFilter: SenderListFilter = {
  page: 0,
  count: 10,
  sort_key: '',
  sort_by: '',
  partner_id: null,
  search: '',
};
